import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {searchStores} from "../../../redux/stores";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SelectInput from "../../../components/select";
import {
    clear_activity,
    CREATE_ACTIVITY,
    createActivity,
    searchActivities,
    searchUserTeamsActivity,
    createActivityLog,
    CREATE_ACTIVITY_LOG,
    updateActivity,
    UPDATE_ACTIVITY
} from "../../../redux/activities";
import Footer from "../../../components/footer";
import Search from "../../../components/search";
import Select from "react-select";
import { searchSubProcess } from "../../../redux/work_subprocess";

const Activities = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();
    const {idUsuario, nombreUsuario, idTienda, nombreTienda, fechaInicio, fechaFin} = useParams();

    // var date = new Date();

    const {token, user} = useSelector((state) => state.users_module.login.data) || null;
    const _create_activity = useSelector((state) => state.activities_module._create_activity);
    const _update_activity = useSelector((state) => state.activities_module._update_activity);

    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [permisos, setPermisos] = useState([]);
    const [stores, setStores] = useState([]);
    // const [tasks, setTasks] = useState([]);
    const [subProcess, setSubProcess] = useState([]);
    // const [workActivities, setWorkActivities] = useState([]);
    const [activities, setActivities] = useState([]);
    const [id_usuario, setIdUsuario] = useState(idUsuario);
    const [usuario, setUsuario] = useState(nombreUsuario);
    const [users, setUsers] = useState([]);
    const [isStore, setIsStore] = useState(false);
    // const [dateStart, setDateStart] = useState(new Date().toLocaleDateString('en-CA'));
    const [dateStart, setDateStart] = useState(fechaInicio);
    const [dateEnd, setDateEnd] = useState(fechaFin);
    // const [task_select, setTaskSelect] = useState([]);
    const [sub_process_select, setSubProcessSelect] = useState([]);
    const [id_tienda, setIdTienda] = useState(idTienda);
    const [nombre_tienda, setNombreTienda] = useState(nombreTienda);
    const [modalReagendar, setModalReagendar] = useState(false);
    const [newDate, setNewDate] = useState('');
    const [newIdStore, setNewIdStore] = useState(0);
    const [reagendar, setReagendar] = useState([]);


    const [form, setForm] = useState({
        // id_actividad_trabajo: 0,
        // actividad_trabajo: "",
        id_subproceso: 0,
        id_tienda: 0,
        tienda: "",
        fecha_agendada: "",
        tarea_reemplazo: false,
        usuario: user,
    });

    useEffect(() => {
        getUserTeamsActivity();
        // getWorkActivities();
        getSubProcess();
        getStores(user, false);
        // eslint-disable-next-line
    }, [token, user]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    async function getUserTeamsActivity() {
        setIsLoading(true);
        if (dateStart === ':fechaInicio' && dateEnd === ':fechaFin') {
            setDateStart(new Date().toLocaleDateString('en-CA'));
            setDateEnd(new Date().toLocaleDateString('en-CA'));
        }
        
        let params = '';
        try {
            const response = await searchUserTeamsActivity(token, params);
            if (response && response.data && response.data.datos) {
                setUsers(response.data.datos);
                setIdUsuario(response.data.datos[0].id);
                setUsuario(response.data.datos[0].nombres);
                getActivities(response.data.datos[0].id);

            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getActivities(id_user) {
        setIsLoading(true);
        let params = '?fecha_inicio=' + dateStart + '&&fecha_fin=' + dateEnd;
        if (id_user !== 0) {
            params += '&&id_usuario=' + id_user;
        }
        if (id_tienda !== 0) {
            params += '&&id_tienda=' + id_tienda;
        }
        try {
            const response = await searchActivities(token, params);
            if (response && response.data && response.data.datos) {
                setActivities(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    // async function getWorkActivities() {
    //     setIsLoading(true);
    //     const params = '';
    //     try {
    //         const response = await searchWorkActivity(token, params);
    //         if (response && response.data && response.data.datos) {

    //             // setWorkActivities(response.data.datos);
    //             let options = [];
    //             // eslint-disable-next-line
    //             response.data.datos.map((item) => {
    //                 options.push({
    //                     value: item.id,
    //                     label: item.nombre,
    //                 });
    //             });
    //             setTasks(options);
    //         }
    //         setIsLoading(false);
    //     } catch (e) {
    //        setIsLoading(false);
    //     }
    // }

    async function getSubProcess() {
        setIsLoading(true);
        const params = '';
        try {
            const response = await searchSubProcess(token, params);
            if (response && response.data && response.data.datos) {
                let values_sub_process = response.data.datos.filter(x => x.activo === true);
                let options = [];
                // eslint-disable-next-line
                values_sub_process.map((item) => {
                    options.push({
                        value: item.id,
                        label: item.nombre,
                    });
                });
                setSubProcess(options);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getStores(user, value) {
        setIsLoading(true);
        const params = value === true ? '' : '?usuario=' + user
        try {
            const response = await searchStores(token, params);
            if (response && response.data && response.data.datos) {
                setStores(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    function changeIsStore(value) {
        getStores(user, value);
        setIsStore(value);
        setForm({
            ...form,
            tarea_reemplazo: value
        });
    }

    const handleChange = (e) => {
        if (e.target.name === "id_actividad" || e.target.name === "id_tienda") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_create_activity.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_activity(CREATE_ACTIVITY));
            getActivities(id_usuario);
            setIsLoading(false);
            setModal(false);
        } else if (_create_activity.status !== 0) {
            dispatch(clear_activity(CREATE_ACTIVITY));
            toast.error(_create_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_activity, dispatch, history, token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        /* if (form.id_actividad_trabajo === 0) {
            toast.error("Debe seleccionar una actividad", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        } */
        if (sub_process_select.length === 0) {
            toast.error("Debe seleccionar una actividad", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_tienda === 0) {
            toast.error("Debe seleccionar una tienda", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.fecha_agendada === "") {
            toast.error("Debe seleccionar una fecha", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        sub_process_select.forEach((x) => {
            form.id_subproceso = x.value;
            dispatch(createActivity(token, form));
        });
    };

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            getActivities(id_usuario);
            return;
        }
        setActivities([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = activities.filter(element => {
            if (element.actividad.match(re) != null) {
                return element;
            }
        })
        setActivities(filtro);
        setIsLoading(false);
    }

    const handleChangeSelect = (e) => {
        // setTaskSelect(e);
        setSubProcessSelect(e);
    };

    const _create_activity_log = useSelector((state) => state.activities_module._create_activity_log);
    

    useEffect(() => {
            if (_create_activity_log.status === 201) {
                dispatch(clear_activity(CREATE_ACTIVITY_LOG));
                getActivities(id_usuario);
                setIsLoading(false);
            } else if (_create_activity_log.status !== 0) {
                dispatch(clear_activity(CREATE_ACTIVITY_LOG));
                toast.error(_create_activity_log.message, {position: toast.POSITION.TOP_RIGHT});
                setIsLoading(false);
            }
            // eslint-disable-next-line
        }, [_create_activity_log, dispatch, history, token]);

    function logActivity(name, id) {
        setIsLoading(true);
        dispatch(createActivityLog(token, {'nombre': name, 'id_actividad': id}));
    }
    
    function handleChangeItem(e, id) {
        if (reagendar.length > 0) {
            // eslint-disable-next-line 
            reagendar.map((x, index) => {
                if (parseInt(x.id) === parseInt(id)){
                    reagendar.splice(index, 1);
                }
            })
        }
        if (e.target.checked === true){
            setReagendar([...reagendar, {id: id, value: e.target.checked}]);
        }
    }

    useEffect(() => {
        if (_update_activity.status === 200) {
            dispatch(clear_activity(UPDATE_ACTIVITY));
            getActivities(id_usuario);
            setModalReagendar(false);
            setIsLoading(false);
        } else if (_update_activity.status !== 0) {
            dispatch(clear_activity(UPDATE_ACTIVITY));
            toast.error(_update_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_activity, dispatch, history, token]);

    function reagendarActividades() {
        if (reagendar.length === 0) {
            toast.error("Selecione las actividades que desea reagendar", {position: toast.POSITION.TOP_RIGHT});
            return;
        }
        setNewDate("");
        setNewIdStore(0);
        document.getElementById("newIdStore").selectedIndex = 0;
        console.log(reagendar);
        setModalReagendar(true);
    };

    function update_activity(v) {
        setIsLoading(true);
        // eslint-disable-next-line
        reagendar.map(x => {
            dispatch(updateActivity(token, x.id, {'tipo': v, 'nueva_fecha': newDate, 'id_tienda': newIdStore}));
            document.getElementById(x.id).checked = false;
        });
        setReagendar([]);
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Agenda"
                            items={[{label: "Consulta de agenda", link: "/actividades"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="row mt-1">
                                    <div className="border_card mb-1 col-12">
                                        <p className="ml-1" style={{marginTop: 10, fontSize: 18, color: '#727E8C'}}>Consulta de agenda mensual</p>
                                    </div>
                                    <div className="border_card col-12">
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Usuario</label>
                                                    <SelectInput
                                                        label="Usuario"
                                                        name="id_usuario"
                                                        value={id_usuario}
                                                        onChange={(e) => setIdUsuario(parseInt(e.target.value))}
                                                        options={users ? users.map((item) => ({
                                                            name: item.nombres,
                                                            id: item.id,
                                                        })) : []}
                                                        select={usuario}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Tienda</label>
                                                    <SelectInput
                                                        label="Tienda"
                                                        id="id_tienda"
                                                        name="id_tienda"
                                                        value={id_tienda}
                                                        onChange={(e) => {
                                                            setIdTienda(parseInt(e.target.value));
                                                            let st = stores.filter(x => x.id === parseInt(e.target.value));
                                                            console.log('tiendas');
                                                            console.log(st);
                                                            if (st) {
                                                                setNombreTienda(st[0].nombre)
                                                            }
                                                        }}
                                                        options={stores ? stores.map((item) => ({
                                                            name: item.nombre,
                                                            id: item.id,
                                                        })) : []}
                                                        select={nombre_tienda}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateStart"
                                                    label="Desde"
                                                    type="date"
                                                    value={dateStart}
                                                    onChange={(e) => {setDateStart(e.target.value)}}
                                                />
                                            </div>
                                            <div className=" col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateEnd"
                                                    label="Hasta"
                                                    type="date"
                                                    value={dateEnd}
                                                    onChange={(e) => {setDateEnd(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-12 text-center">
                                                <Button type="button" text="Buscar" theme="calendar" onClick={() => {
                                                    getActivities(id_usuario);
                                                }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 border_card mt-1">
                                        <div className="row">
                                            <div className="col-md-6 col-12">
                                                <Search placeholder={"Buscar por actividad"}
                                                        onChange={handleSearch}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 text-right">
                                                {
                                                    permisos.filter(x => x.codigo === 'add_activities').length > 0 &&
                                                        <>
                                                        <Button type="button" text="Reagendar" style={{marginRight: 5}} theme="calendar" onClick={() => {
                                                            reagendarActividades();
                                                        }}/>
                                                        <Button type="button" text="Agendar actividad" theme="calendar" onClick={() => {
                                                            // document.getElementById('id_actividad_trabajo').selectedIndex = 0;
                                                            // setTaskSelect([]);
                                                            setSubProcessSelect([]);
                                                            document.getElementById('tiendaId').selectedIndex = 0;
                                                            setModal(true);
                                                            setForm({
                                                                // id_actividad_trabajo: 0,
                                                                // actividad_trabajo: "",
                                                                id_subproceso: 0,
                                                                id_tienda: 0,
                                                                tienda: "",
                                                                fecha_agendada: "",
                                                                usuario: user,
                                                                tarea_reemplazo: false
                                                            })
                                                        }}/>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className='table table-hover'>
                                        <thead>
                                            <tr>
                                                <td></td>
                                                <th>Actividad</th>
                                                {/* <th>Subproceso</th> */}
                                                <th>Proceso</th>
                                                <th>Usuario</th>
                                                <th>Tienda</th>
                                                <th>Fecha agendada</th>
                                                <th>Estado</th>
                                                <th className="text-center">Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activities.map((x) => (
                                                <tr>
                                                    <td><input id={x.id} class="form-check-input" type="checkbox" style={{transform: 'scale(1.5)'}} disabled={(x.log === '' && x.estado === 'Pendiente') ? false : true} onChange={(e) => {handleChangeItem(e, x.id)}}/></td>
                                                    <td>{x.actividad}</td>
                                                    {/* <td>{x.subproceso}</td> */}
                                                    <td>{x.proceso}</td>
                                                    <td>{x.usuario}</td>
                                                    <td>{x.tienda}</td>
                                                    <td>{x.fecha_agendada}</td>
                                                    <td>{x.estado}</td>
                                                    <td className="text-center">
                                                        <Button onChange={() => {history.push(`/actividad/detalle/${x.id}/${id_usuario}/${usuario}/${id_tienda}/${nombre_tienda}/${dateStart}/${dateEnd}`);}} disabled={isLoading} type="button" text="Ver" theme="calendar"/>
                                                        {(x.log === '') ?
                                                                <Button disabled={isLoading} type="button" text="Iniciar" theme="success" classes="mx-1" onChange={() => {
                                                                    logActivity('INICIAR', x.id);
                                                                }}/>
                                                        : (x.log === 'INICIAR' || x.log === 'CONTINUAR') &&
                                                                <Button disabled={isLoading} type="button" text="Pausar" theme="danger" classes="mx-1" onChange={() => {
                                                                    logActivity("PAUSAR", x.id);
                                                                }}/>
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agendar Actividades</h5>
                        <div className="form-group">
                            <label>Sub procesos</label>
                            <Select
                                options={subProcess}
                                isMulti={true}
                                onChange={handleChangeSelect}
                                value={sub_process_select}
                            />
                        </div>
                        {/* <div className="form-group">
                            <label>Actividad</label>
                            <SelectInput
                                id="id_actividad_trabajo"
                                label="Actividad"
                                name="id_actividad_trabajo"
                                value={form.id_actividad_trabajo}
                                select={form.actividad_trabajo}
                                onChange={handleChange}
                                options={workActivities ? workActivities.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div> */}
                        <div className="form-group">
                            <label>Tienda</label>
                            <SelectInput
                                id="tiendaId"
                                label="Tienda"
                                name="id_tienda"
                                value={form.id_tienda}
                                select={form.tienda}
                                onChange={handleChange}
                                options={stores ? stores.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                name="fecha_agendada"
                                type="date"
                                label="Fecha agendada"
                                value={form.fecha_agendada}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input"
                                       onClick={() => {
                                           changeIsStore(!isStore);
                                       }} checked={form.tarea_reemplazo}
                                       style={{width: 15, height: 15, marginTop: -1}}/>
                                <span className="ml-1">Tarea en reemplazo</span>
                            </label>
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main" show={modalReagendar} style={{width: "70%"}}>
                <div className="card-body">
                    <h5 className="titulo_modal type_text mb-2">Reagendar actividades seleccionadas</h5>
                    <div className="form-group">
                        <label>Tienda</label>
                        <SelectInput
                            label="Tienda"
                            id="newIdStore"
                            name="newIdStore"
                            value={newIdStore}
                            onChange={(e) => setNewIdStore(parseInt(e.target.value))}
                            options={stores ? stores.map((item) => ({
                                name: item.nombre,
                                id: item.id,
                            })) : []}
                        />
                    </div>
                    <div className="form-group">
                        <Input
                            label="Fecha"
                            name="newDate"
                            value={newDate}
                            type="date"
                            onChange={(e) => setNewDate(e.target.value)}
                        />
                    </div>
                </div>
                <div className="m-1 text-center">
                    {/*eslint-disable-next-line*/}
                    <a href="#" onClick={() => {
                        update_activity("REAGENDAR");
                    }} className="btn text-bold-700 mb-1 btn_1">
                        Guardar
                    </a>
                    {/*eslint-disable-next-line*/}
                    <a href="#" onClick={() => {
                        setModalReagendar(false);
                    }} className="btn text-bold-700 btn_3">
                        Cancelar
                    </a>
                </div>
            </Modal>
            <Footer/>
        </div>
    );
};

export default Activities;
